import { TableHeader } from "@/models/TableHeader";

export const dashboardStatsHeaders: TableHeader[] = [
  {
    text: "Loc. Code",
    value: "location_code"
  },
  {
    text: "Name",
    value: "name"
  },
  {
    text: "Google Paid",
    value: `stats.google_paid`
  },
  {
    text: "Google Organic",
    value: `stats.google_organic`
  },
  {
    text: "Bing Paid",
    value: `stats.bing_paid`
  },
  {
    text: "Bing Organic",
    value: `stats.bing_organic`
  },
  {
    text: "Yahoo Organic",
    value: `stats.yahoo_organic`
  },
  {
    text: "Direct",
    value: `stats.direct`
  },
  {
    text: "Total",
    value: `stats.total`
  }
];
